import './ScanHistory.css';
import NavBar from './Components/Navbar';
import ScanHistory from './ScanHistory';

const History = () => {
  return (
    <>
    <NavBar />
    <ScanHistory />
    </>
  );
};

export default History;